import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Hint = makeShortcode("Hint");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "where-is-my-public-directory"
    }}>{`Where is my "public" directory?`}</h3>
    <p>{`A public directory is usually a root directory of your server (i.e. `}<inlineCode parentName="p">{`./build`}</inlineCode>{`, `}<inlineCode parentName="p">{`./public`}</inlineCode>{`, or `}<inlineCode parentName="p">{`./dist`}</inlineCode>{`). This directory is often committed to Git, and so should be the Mock Service Worker.`}</p>
    <h4 {...{
      "id": "common-public-directories"
    }}>{`Common public directories`}</h4>
    <p>{`Below you can find a list of public directories in most used JavaScript project starters.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Project name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Public directory`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://create-react-app.dev"
            }}>{`Create React App`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`./public`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.gatsbyjs.org"
            }}>{`GatsbyJS`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`./static`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://nextjs.org"
            }}>{`NextJS`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`./public`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://vuejs.org/"
            }}>{`VueJS`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`./public`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://angular.io/"
            }}>{`Angular`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`./src`}</inlineCode>{` (and add it to the `}<inlineCode parentName="td">{`assets`}</inlineCode>{` of the `}<inlineCode parentName="td">{`angular.json`}</inlineCode>{` file)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://preactjs.com"
            }}>{`Preact`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`./src/static`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <Hint mdxType="Hint">
  Not sure where is your public directory? Reach out to the maintainers of the
  development stack that you are using, they should be able to help.
    </Hint>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      